import {Button} from 'antd'
import dayjs from 'dayjs'
import {course_getCourses_Api,} from 'apis'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useEffect, useMemo, useState,} from 'react'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {BsCalendar3, BsCashCoin, BsHourglassSplit, BsInfoCircleFill, BsPeopleFill, BsPersonFill,} from 'react-icons/bs'
import {PiBooks, PiCertificate} from 'react-icons/pi'
import {TbCertificate, TbCertificateOff} from 'react-icons/tb'
import {RiSubscript} from 'react-icons/ri'
import {useLocation} from 'react-router-dom'
import {course_delivery_mode_options, course_status_options, CourseActionTypes} from 'views/AppLocals/Course'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import CourseFilter from '../components/filters/CourseFilter'
import {FaAward} from "react-icons/fa6";
import {copyLocationParam, getRouteSearchParams, useRouteSearchParam} from "../../../../envs/_current/history";
import {MdOutlineControlPointDuplicate} from "react-icons/md";
import {LuGraduationCap} from "react-icons/lu";
import {CourseContainerContext} from "./CourseContainer";
import {useRouterSearchParam} from "../../../../modules/navigation/useOnLocationChange";
import {useCourseForm} from "../../../AppLocals/Course/CourseClass/useCourseForm";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import classNames from "classnames";
import {EntityPaginationMeta} from "../../../AppLocals/EntityList";
import {CourseStates} from "../WorkspaceCourse";
import {GoDotFill} from "react-icons/go";
import formatCurrency from "../../../Billing/components/formatCurrency";

const renderGridMeta = (props) =>
    (
        <LayoutContext.Consumer>
            {({isLg}) => (
                <div className={classNames(isLg ? 'col-span-2' : 'col-span-1')}>
                    <EntityPaginationMeta
                        {...props}
                        style={{position: 'inherit'}}
                    />
                </div>
            )}
        </LayoutContext.Consumer>
    )

const Courses = ({
                     owner_id,
                     owner_type,
                     filter_actions = {
                         sortBy: 'sort-by',
                         keyword: 'keyword',
                         status: 'course-status',
                         // status_text (Đang chiêu sinh/Đang chạy/Đã kết thúc) trước đây là 3 ROUTE
                         // riêng (?rel=enrolling-courses...), giờ gộp về đúng 1 field filter trong
                         // CourseFilter.js (chip, cùng hàng với Trạng thái bản ghi) - xem lịch sử ở
                         // git blame nếu cần đối chiếu lại route cũ.
                         status_text: 'course-state',
                         academic_year: 'academic-year',
                         academic_field: 'academic-field'
                     },
                 }) => {
    const t = useTranslate()

    const history = useHistory()

    const location = useLocation()

    const [refreshKey, setRefreshKey] = useState()

    const {onChangeSearchParams} = useRouterSearchParam({})
    const {onSelectCourseContainerRoute, setCurrentCourseId} = useContext(CourseContainerContext)

    const sortBy = useRouteSearchParam(filter_actions.sortBy)
    const status = useRouteSearchParam(filter_actions.status)
    const status_text = useRouteSearchParam(filter_actions.status_text)
    const academic_year = useRouteSearchParam(filter_actions.academic_year) || ""
    const academic_field = useRouteSearchParam(filter_actions.academic_field) || ""

    let timeout
    useEffect(() => {
        const searchParams = getRouteSearchParams()
        searchParams.set(filter_actions.status, course_status_options.normal.value)
        timeout = setTimeout(() => {
            history.replace({
                ...copyLocationParam(window.location ?? {}),
                search: '?' + searchParams.toString(),
            })
        })
        return () => clearTimeout(timeout)
    }, [])


    const {
        modal, modalIO,
        handleAction,
        onCancel,
        refreshKey: refreshKeyFromForm
    } = useCourseForm({owner_id, owner_type})

    useEffect(() => {
        setRefreshKey(refreshKeyFromForm)
    }, [refreshKeyFromForm])

    // ?action=create - cho phép nơi khác (nút "Tạo Khóa Mới" ở header access-portal, xem
    // AccessPortalPage.js) điều hướng thẳng vào đây RỒI tự mở modal tạo khóa, không cần biết trước
    // state nội bộ của component này. Xoá param ngay sau khi dùng - tránh mở lại modal khi user back
    // lại trang hoặc refresh.
    const actionParam = useRouteSearchParam('action')
    useEffect(() => {
        if (actionParam !== 'create') return
        handleAction(CourseActionTypes.COURSE_CREATE)
        const sp = getRouteSearchParams()
        sp.delete('action')
        history.replace({search: '?' + sp.toString()})
    }, [actionParam])

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <MdOutlineControlPointDuplicate size={14} className="text-green-500"/>,
                        label: 'copy course',
                        key: CourseActionTypes.COURSE_COPY,
                    },
                    {
                        icon: <LuGraduationCap size={14} className="text-indigo-500"/>,
                        label: 'promote students',
                        key: CourseActionTypes.COURSE_PROMOTE,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: CourseActionTypes.COURSE_UPDATE,
                    },
                    {
                        icon: <RiSubscript size={14} className="text-color-200"/>,
                        label: 'subjects of course',
                        key: CourseActionTypes.SHOW_SUBJECT_LIST_MODAL,
                    },
                    {
                        type: 'divider',
                    },
                    {
                        icon: <PiCertificate size={14} className="text-green-500"/>,
                        label: 'certification',
                        disabled: !!!item?.medal,
                        children: [
                            {
                                key: "COURSE_MEDAL_GRANT_TO_ALL_STUDENTS",
                                label: 'grant to all students',
                                icon: <TbCertificate size={14} className="text-green-600"/>,
                                disabled: !!!item?.medal,
                            },
                            {
                                key: "COURSE_MEDAL_REVOKE_ALL_TO_STUDENTS",
                                label: 'revoke all from students',
                                icon: <TbCertificateOff size={14} className="text-red-600"/>,
                                disabled: !!!item?.medal,
                            },
                            {
                                key: "COURSE_MEDAL_ISSUE_IF_ELIGIBLE",
                                label: 'issue 3rd certificate',
                                icon: <FaAward size={14} className="text-color-300"/>,
                                disabled: !!!item?.medal,
                            }
                        ],
                    },
                    {
                        type: 'divider',
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: CourseActionTypes.COURSE_DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type,
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                status,
                status_text,
                academic_year,
                academic_field
            })
            onSortChange(sortBy)
        },
        pagerInfo: {
            RenderEntity: React.Fragment,
            renderItem: renderCourse({
                translate: t,
                onSelectCourseContainerRoute,
                renderContextMenu,
                handleAction,
            }),
            PaginationMeta: NullAsDefault,
            apiInfo: course_getCourses_Api,
            query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
            renderWrap: (child) => (
                <div className="mt-2 flex flex-col gap-3">
                    {child}
                </div>
            )
        },
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        // isToggleDefault: false,
        query_params: filter_actions,
        AdvancedFilter: CourseFilter,
        dependencies: [owner_id, owner_type],
        withKey: createPagerKey(refresh_deps),
    })


    return (
        <div className="flex flex-1 flex-col space-y-3">
            <div className="flex flex-col md:flex-row md:items-center gap-3">
                <div className="flex flex-col flex-1">
                    <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                        {t('overview')}
                    </h2>
                    <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                    <div className="mt-1 mr-4 text-sm text-color-300 tracking-wider">
                        {t('this is the course library used to build content for courses. manage documents, sample lectures, and assessment standards')}
                    </div>
                </div>
                <Button
                    color="primary" variant="solid"
                    className="px-6 py-2 font-semibold rounded-lg"
                    onClick={() => {
                        handleAction(CourseActionTypes.COURSE_CREATE)
                    }}>
                    {t('create course')}
                </Button>
            </div>
            {pager_widget}
            {modal}
            {!!modalIO ? modalIO : null}
            <div className="h-16"/>
        </div>
    )
}


// Viền trái theo trạng thái - khớp đúng màu đã dùng cho badge trạng thái (CourseStates,
// WorkspaceCourse.js) để nhất quán 1 mã màu duy nhất cho mỗi trạng thái trên toàn màn.
const accentBorderColor = {
    enrollment_open: '#48bb78',
    in_process: '#60a5fa',
    completed: '#d1d5db',
}

// Số ngày kể từ lúc khóa kết thúc vẫn còn coi là "vừa kết thúc" để gợi ý copy sang khóa mới - quá
// mốc này thì thôi, tránh khóa đã đóng cả năm vẫn bị nhắc hoài (gợi ý hết "duyên").
const RECENTLY_ENDED_DAYS = 60

const isRecentlyEnded = (time_close) =>
    !!time_close && dayjs().diff(dayjs(time_close), 'day') <= RECENTLY_ENDED_DAYS

const renderCourse = ({onSelectCourseContainerRoute, translate: t, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {
    const {
        course_idcode,
        title,
        description,
        time_open,
        time_close,
        last_enrollment_time,
        coordinator_name,
        student_quota,
        delivery_mode,
        fee_amount,
        fee_currency_code,
        course_state,
        course_class_count,
        student_count,
        curriculum,
    } = item ?? {}

    const stateInfo = _.find(CourseStates, {value: course_state})
    const deliveryModeOption = _.find(course_delivery_mode_options, {value: delivery_mode})
    const hasFee = fee_amount !== null && fee_amount !== undefined
    const feeLabel = hasFee
        ? (Number(fee_amount) === 0 ? t('free') : formatCurrency(fee_amount, {style: 'currency', currency: fee_currency_code || 'VND'}))
        : null

    // Gợi ý "copy course"/"promote students" - 2 CHỨC NĂNG ĐÃ CÓ SẴN trong context menu (bấm "...")
    // nhưng rất ít người biết tới, nằm im lìm hoài dễ bị bỏ qua. Chỉ hiện đúng lúc có ích (khóa VỪA
    // kết thúc gần đây → gợi mở đợt mới; khóa CHƯA có học viên nào và chưa kết thúc → gợi chuyển học
    // viên khóa cũ lên) - không hiện tràn lan trên mọi khóa để khỏi "vô duyên". Bấm thẳng vào gợi ý
    // là mở LUÔN đúng modal đó (handleAction), không chỉ là dòng chữ suông.
    const showCopyHint = course_state === 'completed' && isRecentlyEnded(time_close)
    const showPromoteHint = course_state !== 'completed' && !student_count

    return (
        <div
            key={index}
            style={{borderLeftWidth: 4, borderLeftColor: accentBorderColor[course_state] ?? '#e5e7eb'}}
            className="p-4 flex flex-col gap-2 border border-color-100 background rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 relative custom-item-render">

            {/* Mã khóa + trạng thái + thao tác */}
            <div className="flex items-start justify-between gap-2">
                {course_idcode && (
                    <span className="px-2 py-0.5 rounded-md bg-blue-50 font-mono text-2xs font-bold text-blue-500 tracking-wider whitespace-no-wrap">
                        {course_idcode}
                    </span>
                )}
                <div className="ml-auto flex items-center gap-2 flex-shrink-0">
                    {stateInfo && (
                        <span
                            className={classNames(
                                "px-2.5 py-1 flex items-center gap-1 rounded-full text-2xs font-semibold whitespace-no-wrap tracking-wider",
                                stateInfo.className
                            )}>
                            <GoDotFill size={8}/>
                            {t(stateInfo.label)}
                        </span>
                    )}
                    {_.isFunction(renderContextMenu) && (
                        <div className="contextIcon">
                            {renderContextMenu(item)}
                        </div>
                    )}
                </div>
            </div>

            <h2
                onClick={() => onSelectCourseContainerRoute({current_course_id: item.id})}
                className="font-bold text-lg text-color-000 hover:text-primary cursor-pointer leading-snug">
                {title}
            </h2>

            {description && (
                <div className="text-sm text-color-300 tracking-wide leading-relaxed max-lines-2">
                    {description}
                </div>
            )}

            {/* Thông tin nhanh */}
            <div className="mt-1 p-3 rounded-xl background-100 grid grid-cols-1 sm:grid-cols-3 gap-x-4 gap-y-2 text-xs">
                {time_open && (
                    <span className="flex items-center gap-1.5 text-color-200 truncate">
                        <BsCalendar3 size={12} className="flex-shrink-0 text-color-400"/>
                        <span className="text-color-400">{`${t('time')}: `}</span>
                        <span className="font-medium truncate">
                            {formatSimplifyDate(time_open, 'medium')}
                            {time_close && ` → ${formatSimplifyDate(time_close, 'medium')}`}
                        </span>
                    </span>
                )}
                {last_enrollment_time && (
                    <span className="flex items-center gap-1.5 text-color-200 truncate">
                        <BsHourglassSplit size={12} className="flex-shrink-0 text-orange-400"/>
                        <span className="text-color-400">{`${t('registration deadline')}: `}</span>
                        <span className="font-medium truncate">{formatSimplifyDate(last_enrollment_time, 'medium')}</span>
                    </span>
                )}
                {deliveryModeOption && (
                    <span className="flex items-center gap-1.5 text-color-200 truncate">
                        <span className="flex-shrink-0 text-purple-500">{deliveryModeOption.icon}</span>
                        <span className="text-color-400">{`${t('delivery mode')}: `}</span>
                        <span className="font-medium truncate">{t(deliveryModeOption.label)}</span>
                    </span>
                )}
                {coordinator_name && (
                    <span className="flex items-center gap-1.5 text-color-200 truncate">
                        <BsPersonFill size={12} className="flex-shrink-0 text-color-400"/>
                        <span className="text-color-400">{`${t('coordinator')}: `}</span>
                        <span className="font-medium truncate">{coordinator_name}</span>
                    </span>
                )}
                {!!student_quota && (
                    <span className="flex items-center gap-1.5 text-color-200 truncate">
                        <BsPeopleFill size={12} className="flex-shrink-0 text-color-400"/>
                        <span className="text-color-400">{`${t('quota')}: `}</span>
                        <span className="font-medium truncate">{student_quota} {t('students').toLowerCase()}</span>
                    </span>
                )}
                {feeLabel && (
                    <span className="flex items-center gap-1.5 text-color-200 truncate">
                        <BsCashCoin size={12} className="flex-shrink-0 text-green-500"/>
                        <span className="text-color-400">{`${t('tuition fee')}: `}</span>
                        <span className="font-medium truncate">{feeLabel}</span>
                    </span>
                )}
            </div>

            {showCopyHint && (
                <button
                    type="button"
                    onClick={() => handleAction(CourseActionTypes.COURSE_COPY, item)}
                    className="mt-1 flex items-center gap-2 px-3 py-2 border border-dashed border-indigo-200 bg-indigo-50/60 hover:bg-indigo-50 rounded-lg text-left transition-colors">
                    <MdOutlineControlPointDuplicate size={14} className="text-indigo-500 flex-shrink-0"/>
                    <span className="flex-1 text-xs text-indigo-700 leading-snug">
                        {t('course recently ended copy hint')}
                    </span>
                </button>
            )}
            {showPromoteHint && (
                <button
                    type="button"
                    onClick={() => handleAction(CourseActionTypes.COURSE_PROMOTE, item)}
                    className="mt-1 flex items-center gap-2 px-3 py-2 border border-dashed border-green-200 bg-green-50/60 hover:bg-green-50 rounded-lg text-left transition-colors">
                    <LuGraduationCap size={14} className="text-green-600 flex-shrink-0"/>
                    <span className="flex-1 text-xs text-green-700 leading-snug">
                        {t('course no students promote hint')}
                    </span>
                </button>
            )}

            {/* Chương trình đào tạo + tổng quan lớp/học viên + link chi tiết */}
            <div className="mt-2 flex flex-wrap items-center justify-between gap-2">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                    {curriculum?.title && (
                        <span className="flex items-center gap-1 px-2 py-0.5 bg-slate-100 border border-slate-200 rounded-full">
                            <PiBooks size={12} className="text-slate-400 flex-shrink-0"/>
                            <span className="font-medium text-xs text-slate-500 tracking-wider truncate">
                                {curriculum.title}
                            </span>
                        </span>
                    )}
                    {course_class_count > 0 && (
                        <span className="flex items-center gap-1 font-medium text-xs text-color-100 italic">
                            <GoDotFill size={10} className="text-color-500"/>
                            {`${course_class_count} ${t('classes').toLowerCase()}`}
                        </span>
                    )}
                    {student_count > 0 && (
                        <span className="flex items-center gap-1 font-medium text-xs text-color-100 italic">
                            <GoDotFill size={10} className="text-color-500"/>
                            {`${student_count} ${t('students').toLowerCase()}`}
                        </span>
                    )}
                </div>
                <span
                    onClick={() => onSelectCourseContainerRoute({current_course_id: item.id})}
                    className="flex items-center gap-1 text-xs font-semibold text-primary-600 hover:text-primary cursor-pointer whitespace-no-wrap">
                    <BsInfoCircleFill size={12}/>
                    {t('view course detail')}
                </span>
            </div>
        </div>
    )
}


export default Courses
